var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"placeholder":"Ваша відповідь","solo":"","flat":"","dense":"","background-color":"#f5f5f5"},on:{"input":_vm.onTextChange},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }